import { Injectable, inject } from '@angular/core';
import { SystemItem } from '@nx-customer-apps/api-planning-projects';
import { DecimalMarker, Mask, MaskService } from '@nx-customer-apps/components';
import { getPostalCodeMask, numericHint } from '@nx-customer-apps/shared/utils';
import { LocaleService } from './locale.service';

@Injectable({
    providedIn: 'root'
})
export class FormToolsService {
    private localeService = inject(LocaleService);
    private maskService = inject(MaskService);

    public getNumericMask(options?: { separatorLimit?: string; numberOfDecimals?: string }): Mask {
        const maskOptions = {
            separatorLimit: options?.separatorLimit,
            numberOfDecimals: options?.numberOfDecimals,
            decimalMarker: this.localeService.getDecimalMarker() as DecimalMarker
        };
        return this.maskService.getNumericMask(maskOptions);
    }

    public getNumericHint(): (value: string) => string | null {
        const decimalMarker = this.localeService.getDecimalMarker();
        return numericHint(decimalMarker);
    }

    public hasBoilerOptionsToAsk(installationType: SystemItem | undefined): boolean {
        return !!installationType?.isLowTemperature || !!installationType?.warmWaterByHeatGenerator;
    }

    public getPostalCodeMask(countryCode: string) {
        return getPostalCodeMask(countryCode);
    }

    public getLimitedTextMask(numberOfLetters: number): Mask {
        return this.maskService.getLimitedTextMask({ numberOfLetters });
    }

    public hasHeatGeneratorInstallationYearHint(
        heatGeneratorInstallationYear: string | undefined,
        buildingConstructionYear: number | undefined
    ): boolean {
        return !heatGeneratorInstallationYear && !!buildingConstructionYear;
    }
}
